angular.module('impactx.login').controller('LoginOpenIdCtrl', LoginOpenIdCtrl);

LoginOpenIdCtrl.$inject = ['LoginService', '$securityManager', '$routeParams', 'dataGen', 'OpenIdService'];

function LoginOpenIdCtrl(LoginService, $securityManager, $routeParams, dataGen, OpenIdService) {
    var params = OpenIdService.getLastOpenIdParams();
    var token = params["id_token"];
    var accessToken = params["access_token"];
    OpenIdService.setLastOpenIdParams({});
    var osuTan = $routeParams.osuTan;

    dataGen.postAsForm({}, {id_token: token, access_token: accessToken}, "/login/openid").then(function() {
        LoginService.refreshUI(true, osuTan);
    });
}